import { Angry, Meh } from 'lucide-react'

import { Frown, Smile } from 'lucide-react'

import { Laugh } from 'lucide-react'
import { FULL_TIME_VALUE, W2_TAX_STATUS } from './current-job-pane-config'

export enum RetirementPlan {
  a401 = '401a',
  k401 = '401k',
  b403 = '403b',
  b457 = '457b',
  Pension = 'pension',
}

export const retirementPlans = [
  { label: '401(a)', id: RetirementPlan.a401 },
  { label: '401(k)', id: RetirementPlan.k401 },
  { label: '403(b)', id: RetirementPlan.b403 },
  { label: '457(b)', id: RetirementPlan.b457 },
  { label: 'Pension', id: RetirementPlan.Pension },
]

export const insuranceHealthBenefits = [
  { label: 'Health', id: 'health' },
  { label: 'Life Insurance', id: 'lifeInsurance' },
  { label: 'Dental', id: 'dental' },
  { label: 'LT Disability', id: 'ltDisability' },
  { label: 'Vision', id: 'vision' },
  { label: 'ST Disability', id: 'stDisability' },
]

export const MALPRACTICE_YES_ID = 'yes'
export const malpracticeInsuranceOptions = [
  { label: 'Yes', id: MALPRACTICE_YES_ID },
  { label: 'No', id: 'no' },
]

export const LOAN_ASSISTANCE = 'loanAssistance'
export const PARENTAL_LEAVE = 'parentalLeave'
export const otherBenefits = [
  { label: 'Loan Assistance', id: LOAN_ASSISTANCE },
  { label: 'Parental Leave', id: PARENTAL_LEAVE },
]

export const satisfactionOptions = [
  {
    label: 'Very Satisfied',
    id: 'verySatisfied',
    icon: Laugh,
    color: 'green-40',
  },
  { label: 'Satisfied', id: 'satisfied', icon: Smile, color: 'green-50' },
  { label: 'Ok', id: 'ok', icon: Meh, color: 'yellow-40' },
  { label: 'Dissatisfied', id: 'dissatisfied', icon: Frown, color: 'red-40' },
  {
    label: 'Very Dissatisfied',
    id: 'veryDissatisfied',
    icon: Angry,
    color: 'red-40',
  },
] as const;

export const weeksRules = {
  min: { value: 0, message: 'Must be a positive number' },
  max: { value: 52, message: 'Cannot be larger than 52' },
}

export const ptoWeeksRequired = (jobType: string, taxStatus?: string[]) => 
  jobType === FULL_TIME_VALUE && taxStatus?.includes(W2_TAX_STATUS) 
    ? 'Weeks of PTO is required'
    : false
export const cmeAllowanceRules = {
  min: { value: 0, message: 'Must be at least $0' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999' },
}

export const loanAssistanceRules = {
  min: { value: 1, message: 'Must be at least $1' },
  max: { value: 999999999, message: 'Cannot be more than $999,999,999' },
}

export const tailCoverageOptions = [
  { label: 'Employer Paid', id: 'employerPaid' },
  { label: 'Employee Paid', id: 'employeePaid' },
  { label: 'Shared Cost', id: 'sharedCost' },
]

export const tailCoverageDisplay = Object.entries(tailCoverageOptions).reduce(
  (acc, [_index, { id, label }]) => {
    acc[id] = `(${label})`
    return acc
  },
  {} as Record<string, string>,
)
